module.exports = __webpack_public_path__ + "static/media/nbe.e6e9cb9c.jpeg";